/**
 * Sorts an array of objects alphabetically by a specified key
 * @param {Array} array - The array to sort
 * @param {string} key - The property key to sort by (default: 'name')
 * @param {string} order - Sort order: 'asc' or 'desc' (default: 'asc')
 * @returns {Array} - A new sorted array
 */
export const sortAlphabetically = (array, key = 'name', order = 'asc') => {
  if (!Array.isArray(array)) {
    console.warn('sortAlphabetically: Expected an array, received:', typeof array);
    return [];
  }

  return [...array].sort((a, b) => {
    const valueA = (a[key] || "").trim().toLowerCase();
    const valueB = (b[key] || "").trim().toLowerCase();
    
    const comparison = valueA.localeCompare(valueB);
    
    return order === 'desc' ? -comparison : comparison;
  });
};

/**
 * Sorts an array of strings alphabetically
 * @param {Array} array - Array of strings to sort
 * @param {string} order - Sort order: 'asc' or 'desc' (default: 'asc')
 * @returns {Array} - A new sorted array
 */
export const sortStringsAlphabetically = (array, order = 'asc') => {
  if (!Array.isArray(array)) {
    console.warn('sortStringsAlphabetically: Expected an array, received:', typeof array);
    return [];
  }

  return [...array].sort((a, b) => {
    const valueA = (a || "").trim().toLowerCase();
    const valueB = (b || "").trim().toLowerCase();
    
    const comparison = valueA.localeCompare(valueB);
    
    return order === 'desc' ? -comparison : comparison;
  });
};